import Vue from 'vue'
import { mapState, mapMutations } from 'vuex'
import App from '@/App.vue'
import router from '@/router'
import store from '@/store'
import Vuelidate from 'vuelidate'
import VueTheMask from 'vue-the-mask'
import VueSentry from '@/utils/sentry'
import { loadDefaultPlan } from './products'
import { datadogRum } from '@datadog/browser-rum'

console.info(`${process.env.VUE_APP_JOURNEY_NAME.toUpperCase()} v${process.env.VUE_APP_VERSION}`)

// Datadog RUM is only enabled in production
const _env = process.env.VUE_APP_ENV || process.env.NODE_ENV
if (_env === 'production') {
  datadogRum.init({
    applicationId: 'f100c55a-cbb9-48d5-bb82-5b1f8f36ceea',
    clientToken: 'pubc2286833cc876b76c27a92f1333794f0',
    site: 'datadoghq.com',
    service: 'paguemenos',
    env: process.env.VUE_APP_ENV || process.env.NODE_ENV,
    version: process.env.VUE_APP_VERSIO,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 100,
    trackUserInteractions: true,
    enableExperimentalFeatures: ['clickmap'],
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: 'mask-user-input'
    // allowedTracingUrls: [process.env.VUE_APP_API_URL, url => url.startsWith(process.env.VUE_APP_API_URL)]
  })

  datadogRum.startSessionReplayRecording()
}

Vue.config.productionTip = false

Vue.use(Vuelidate)
Vue.use(VueTheMask)
Vue.use(VueSentry)

loadDefaultPlan()
  .then(() => {
    new Vue({
      router,
      store,
      created () {
        if (/operador|funcionario/.test(process.env.VUE_APP_JOURNEY_NAME)) {
          this.setIsOperator(process.env.VUE_APP_JOURNEY_NAME === 'operador')
          this.setIsEmployee(process.env.VUE_APP_JOURNEY_NAME === 'funcionario')

          return
        }

        this.injectScript()
      },
      watch: {
        name () {
          document.title = `${this.name} | Sempre Bem Ouro +`
        }
      },
      computed: {
        ...mapState('product', ['name'])
      },
      methods: {
        ...mapMutations(['setIsOperator', 'setIsEmployee']),
        injectScript () {
          const elScript = document.createElement('script')
          elScript.setAttribute(
            'src',
            `https://www.google.com/recaptcha/api.js?render=${process.env.VUE_APP_RECAPTCHA}`
          )
          elScript.setAttribute('async', true)
          elScript.setAttribute('defer', true)
          document.body.appendChild(elScript)
        }
      },
      render: (h) => h(App)
    }).$mount('#app')
  })
  .catch((error) => {
    console.error(error)
    document.querySelector('#app').innerHTML = `
    <main style="text-align: center; margin: 0 auto; padding: 100px 0;">
      <svg width="100" height="100" viewBox="0 0 24 24" fill="none" stroke="#ff000088" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <circle cx="12" cy="12" r="10"></circle>
        <line x1="12" y1="8" x2="12" y2="12"></line>
        <line x1="12" y1="16" x2="12" y2="16"></line>
      </svg>
      <h1 style="margin-block: 1rem">Erro ao carregar o produto</h1>
      <p>Por favor, tente novamente mais tarde.</p>
    </main>
  `
  })
